import React from 'react';
import DeactivateAccountForm from '../UI/Form/DeactivateAccountForm';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const DeactivateAccount = ({ setShowDeactivateAccount }) => {
    const { content } = useContentfulContext();

    return (
        <>
            <div className="p-6 text-left">
                <a href="#" className="font-medium text-primary hover:underline flex items-center mb-4" onClick={(e) => {
                    e.preventDefault();
                    setShowDeactivateAccount(false)
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" className="injected-svg fill-current mr-2"><line x1="8.75" y1="12" x2="17.25" y2="12" stroke="white" strokeWidth="1.5" strokeLinecap="round"></line><path fillRule="evenodd" clipRule="evenodd" d="M11.5302 4.53033C11.8231 4.23744 11.8231 3.76256 11.5302 3.46967C11.2373 3.17678 10.7624 3.17678 10.4695 3.46967L3.17663 10.7626C2.49321 11.446 2.49321 12.554 3.17663 13.2374L10.4695 20.5303C10.7624 20.8232 11.2373 20.8232 11.5302 20.5303C11.8231 20.2374 11.8231 19.7626 11.5302 19.4697L4.81051 12.75H21.2499C21.6641 12.75 21.9999 12.4142 21.9999 12C21.9999 11.5858 21.6641 11.25 21.2499 11.25H4.81051L11.5302 4.53033Z"></path></svg>Back
                </a>
                <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-2">{content.DEACTIVATE_ACCOUNT_MODAL.title}</h2>
                <p className='text-base leading-tight tracking-tight text-black mb-4'>{content.DEACTIVATE_ACCOUNT_MODAL.description}</p>
                <DeactivateAccountForm submitHandler={() => {}} handleCancelClick={() => { setShowDeactivateAccount(false) }}/>
            </div>
        </>
    )
}

export default DeactivateAccount;